module.exports = __webpack_public_path__ + "static/safaahanaa-4359d0779a5b874aa8aadcc853457d07.jpg";